export default {
  'menu.welcome': 'ようこそ',
  'menu.more-blocks': 'その他のブロック',

  // 1. コンソール
  'menu.dashboard': 'コンソール',
  'menu.dashboard.workplace': 'ワークプレイス',

  // 2. アプリセンター
  'menu.app': 'アプリセンター',
  'menu.app.mine': 'マイアプリ',
  'menu.app.appName': 'アプリ',
  'menu.app.mgmt': 'アプリ管理',
  'menu.app.mgmt.list': 'アプリ一覧',
  'menu.app.mgmt.create': 'アプリ作成',
  'menu.app.mgmt.edit': 'アプリ編集',
  'menu.app.mgmt.detail': 'アプリ詳細',
  'menu.app.mgmt.analysis': '総合データ',
  'menu.app.mgmt.appName': 'アプリ',
  'menu.app.next-chat': 'チャット',
  'menu.app.next-search': '検索',
  'menu.app.agent': 'エージェント',
  'menu.app.memory': 'メモリ',

  // 3. データ管理
  'menu.data': 'データ管理',
  'menu.datasets': 'ナレッジベース',
  'menu.data.dataset': 'ナレッジベース',
  'menu.data.dataset.create': 'ナレッジ作成',
  'menu.data.dataset.edit': 'ナレッジ編集',
  'menu.data.dataset.detail': 'ナレッジコンテンツ管理',
  'menu.data.dataset.detail.file': 'ファイルプレビュー',
  'menu.data.file': 'ファイルセンター',
  'menu.file.preview': 'ファイルプレビュー',

  // 4. 統計分析
  'menu.analysis': '統計分析',
  'menu.analysis.access': 'アクセスレポート',
  'menu.analysis.access.login': 'ログイン履歴',
  'menu.analysis.access.action': '操作監査',
  'menu.analysis.access.app': 'アプリ使用統計',
  'menu.analysis.access.app-detail': 'アプリケーションアクセス詳細',
  'menu.analysis.access.user-login-detail': 'ログイン詳細',
  'menu.analysis.audit': '権限監査',
  'menu.analysis.audit.user': 'ユーザー権限',
  'menu.analysis.audit.role-assign': 'ロール割当',
  'menu.analysis.audit.role-detail': 'ロール権限詳細',
  'menu.analysis.audit.app': 'アプリアクセス権限',
  'menu.analysis.audit.user-permission-detail': 'ユーザー権限詳細',

  // 5. 組織管理
  'menu.org': '組織管理',
  'menu.org.user': 'ユーザー管理',
  'menu.org.user.permission': 'ユーザー権限管理',
  'menu.org.user.add': 'ユーザー作成',
  'menu.org.user.batchImportUser': 'ユーザー一括インポート',
  'menu.org.user.edit': 'ユーザー編集',
  'menu.org.user.detail': 'ユーザー詳細',
  'menu.org.role': 'ロール管理',
  'menu.org.role.add': 'ロール作成',
  'menu.org.role.edit': 'ロール編集',
  'menu.org.role.copy': 'ロールをコピー',
  'menu.org.company': '会社管理',
  'menu.org.company.create': '会社作成',
  'menu.org.company.edit': '会社編集',
  'menu.org.company.setting': '会社設定',
  'menu.org.dept': '部門管理',
  'menu.org.dept.create': '部署作成',
  'menu.org.dept.edit': '部署編集',

  // 6. システム設定
  'menu.system': 'システム設定',
  'menu.system.menu': 'メニュー設定',
  'menu.system.app-config': 'アプリ設定',
  'menu.system.data-source': 'データソース',
  'menu.system.config': '全般設定',
  'menu.system.license': 'ライセンス管理',
  'menu.system.changelog': '更新履歴',
  'menu.system.info': 'システム情報',

  // その他
  'menu.login': 'ログイン',
  'menu.register': '登録',
  'menu.register-result': '登録結果',
  'menu.exception': '例外',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'トリガー',
  'menu.403': '403',
  'menu.account': 'アカウント',
  'menu.account.center': 'アカウントセンター',
  'menu.account.settings': 'アカウント設定',
  'menu.account.trigger': 'トリガーエラー',
  'menu.account.logout': 'ログアウト',

  // ─── 非ナビゲーション操作（状態切替 / フォーム送信 / 一括操作）───
  'menu.org.company.create.submit': '会社を作成 - 送信',
  'menu.org.company.edit.submit': '会社を編集 - 送信',
  'menu.org.company.enable': '会社を有効化',
  'menu.org.company.disable': '会社を無効化',
  'menu.org.company.export': '会社管理 - エクスポート',
  'menu.org.dept.create.submit': '部門を作成 - 送信',
  'menu.org.dept.edit.submit': '部門を編集 - 送信',
  'menu.org.dept.export': '部門管理 - エクスポート',
  'menu.org.role.add.submit': 'ロールを作成 - 送信',
  'menu.org.role.edit.submit': 'ロールを編集 - 送信',
  'menu.org.role.copy.submit': 'ロールをコピー - 送信',
  'menu.org.role.enable': 'ロールを有効化',
  'menu.org.role.disable': 'ロールを無効化',
  'menu.org.role.batch_enable': 'ロールを一括有効化',
  'menu.org.role.batch_disable': 'ロールを一括無効化',
  'menu.org.role.export': 'ロール管理 - エクスポート',
  'menu.org.user.add.submit': 'ユーザーを作成 - 送信',
  'menu.org.user.edit.submit': 'ユーザーを編集 - 送信',
  'menu.org.user.enable': 'ユーザーを有効化',
  'menu.org.user.disable': 'ユーザーを無効化',
  'menu.org.user.copy': 'ユーザーをコピー',
  'menu.org.user.resetPassword': 'パスワードをリセット',
  'menu.org.user.permission.manager.set': 'ユーザー権限管理 - 管理者に設定',
  'menu.org.user.permission.manager.cancel': 'ユーザー権限管理 - 管理者を解除',
  'menu.org.user.permission.resetPassword': 'ユーザー権限管理 - パスワードをリセット',
  'menu.org.user.permission.role.add': 'ユーザー権限管理 - ロール追加',
  'menu.org.user.permission.role.add.submit': 'ユーザー権限管理 - ロール追加 - 送信',
  'menu.org.user.permission.role.remove': 'ユーザー権限管理 - ロール削除',
  'menu.org.user.permission.reference': 'ユーザー権限管理 - 権限を参照',
  'menu.org.user.permission.reference.submit': 'ユーザー権限管理 - 権限を参照 - 送信',
  'menu.org.user.permission.customize.submit': 'ユーザー権限管理 - カスタム権限を送信',
  'menu.org.user.permission.restore': 'ユーザー権限管理 - デフォルト権限に復元',
  'menu.org.user.export': 'ユーザー管理 - エクスポート',
  'menu.org.user.print': 'ユーザー管理 - 印刷',
  'menu.org.role.print': 'ロール管理 - 印刷',
  'menu.org.company.print': '会社管理 - 印刷',
  'menu.org.dept.print': '部門管理 - 印刷',
  'menu.analysis.access.action.export': '操作監査 - エクスポート',
  'menu.analysis.access.action.print': '操作監査 - 印刷',
  'menu.analysis.access.login.export': 'システムアクセスレポート - エクスポート',
  'menu.analysis.access.login.print': 'システムアクセスレポート - 印刷',
  'menu.analysis.access.app.export': 'アクセス統計の適用 - エクスポート',
  'menu.analysis.access.app.print': 'アクセス統計の適用 - 印刷',
  'menu.analysis.access.app-detail.export': 'アクセス詳細の適用 - エクスポート',
  'menu.analysis.access.app-detail.print': 'アクセス詳細の適用 - 印刷',
  'menu.analysis.audit.user.export': 'ユーザー権限レポート - エクスポート',
  'menu.analysis.audit.user.print': 'ユーザー権限レポート - 印刷',
  'menu.analysis.audit.role-assign.export': 'ロール認可レポート - エクスポート',
  'menu.analysis.audit.role-assign.print': 'ロール認可レポート - 印刷',
  'menu.analysis.audit.role-detail.export': '役割権限詳細 - エクスポート',
  'menu.analysis.audit.role-detail.print': '役割権限詳細 - 印刷',
  'menu.analysis.audit.app.export': 'アクセス権適用レポート - エクスポート',
  'menu.analysis.audit.app.print': 'アクセス権適用レポート - 印刷',
  'menu.system.menu.edit.submit': 'メニュー設定 - 編集送信',
  'menu.system.menu.drag.submit': 'メニュー設定 - ドラッグソート',
  'menu.app.mgmt.list.add': 'アプリケーション作成',
  'menu.app.mgmt.list.edit': 'アプリケーション編集',
  'menu.app.mgmt.list.config': 'アプリケーション設定',
  'menu.app.mgmt.list.enable': 'アプリケーション有効化',
  'menu.app.mgmt.list.disable': 'アプリケーション無効化',
  'menu.app.mgmt.list.export': 'アプリケーション管理 - エクスポート',
  'menu.app.mgmt.list.print': 'アプリケーション管理 - 印刷',
};
